import React from 'react';
import { ModalFooter } from '@amzn/meridian/modal';
import Link from '@amzn/meridian/link';
import Row from '@amzn/meridian/row';
import Column from '@amzn/meridian/column';
import Text from '@amzn/meridian/text';
import Button from '@amzn/meridian/button';
import PropTypes from 'prop-types';
import ButtonWithToolTip from './ButtonWithToolTip';
import {
  FEEDBACK_LINKS,
  REQUIRED_QUESTION_TITLE,
  SUBMIT_BUTTON_PROPERTIES,
} from '../constants/FeedbackConstants';

const SkippableFooter = ({
  onClose,
  isDisabled,
  onClickFooterButton,
  submitButtonSize,
  submitButtonType,
  submitButtonText,
}) => {
  return (
    <ModalFooter>
      <Row
        spacingInset="medium"
        width="100%"
        widths={['grid-1', 'grid-9', 'grid-2']}>
        <Link onClick={onClose}>
          <Text type="d50">{FEEDBACK_LINKS.skip}</Text>
        </Link>
        <Column />
        {isDisabled ? (
          <ButtonWithToolTip
            onClickFooterButton={onClickFooterButton}
            title={REQUIRED_QUESTION_TITLE}
            submitButtonSize={submitButtonSize}
            submitButtonType={submitButtonType}
            submitButtonText={submitButtonText}
          />
        ) : (
          <Button
            type={submitButtonType}
            size={submitButtonSize}
            onClick={onClickFooterButton}>
            {submitButtonText}
          </Button>
        )}
      </Row>
    </ModalFooter>
  );
};

SkippableFooter.propTypes = {
  onClose: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  onClickFooterButton: PropTypes.func.isRequired,
  submitButtonSize: PropTypes.string,
  submitButtonType: PropTypes.string,
  submitButtonText: PropTypes.string,
};

SkippableFooter.defaultProps = {
  submitButtonSize: SUBMIT_BUTTON_PROPERTIES.size,
  submitButtonType: SUBMIT_BUTTON_PROPERTIES.type,
  submitButtonText: SUBMIT_BUTTON_PROPERTIES.text,
};

export default SkippableFooter;
